/*
 * @Author: wuqinfa
 * @Date: 2022-11-22 10:54:38
 * @LastEditors: wuqinfa
 * @Description: 把请求的报错信息格式化打印处理
 */
import type { ErrorInfo } from './interface';

export default function printErrorInfo(error: ErrorInfo) {
  console.log('error :>> ', error);
  
  const {
    config,
    request,
    data,
  } = error;
  const {
    url,
    method,
    baseURL,
    headers,
    data: requestData,
    params,
  } = config;
  const {
    status,
  } = request;
  const {
    code,
    message,
  } = data || {};
  
  const errorTagStyle = [
    'color: #ff4d4f',
    'background: #fff2f0',
    'padding: 2px 6px',
    'font-size: 12px',
    'border-radius: 2px',
    'border: 1px solid #ff4d4f',
  ].join(';');

  console.log('%c接口报错信息', errorTagStyle);
  console.log(`
------------- error-start -------------
时间：${new Date().toString()}
HTTP Status：${status}
baseURL：${baseURL}
接口路径：${url}
请求类型：${method}
headers：${JSON.stringify(headers)}
params 参数：${JSON.stringify(params || {})}
data 参数：${JSON.stringify(requestData || {})}
接口返回的 code：${code}
接口返回的 message：${message}
------------- error-end ---------------
  `);
}